/**
 * Formats a landline phone number by removing any international prefixes and ensuring it starts with '0'.
 *
 * @param {string} number - The phone number to be formatted.
 * @returns {string} The formatted phone number with the correct prefix.
 */
export const formatLandlineNumber = (number) => {
    const prefixes = ['00310', '0031', '310', '31', '0'];
    let formattedNumber = number;
    prefixes.some((prefix) => {
        if (new RegExp(`^${prefix}`).test(number)) {
            formattedNumber = number.replace(new RegExp(`^${prefix}`), '0');
            return true;
        }
        return false;
    });
    return formattedNumber;
};
/**
 * Formats a mobile phone number by removing the country code and adding a space after the '06' prefix.
 *
 * @param {string} number - The mobile phone number to be formatted.
 * @returns {string} The formatted mobile phone number with a space after the '06' prefix.
 */
export const formatMobileNumber = (number) => {
    const prefixes = ['003106', '00316', '3106', '316', '06'];
    let formattedNumber = number;
    prefixes.some((prefix) => {
        if (new RegExp(`^${prefix}`).test(number)) {
            formattedNumber = number.replace(new RegExp(`^${prefix}`), '06 ');
            return true;
        }
        return false;
    });
    return formattedNumber;
};
